exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active,.fade-leave-active{transition:all .1s}.fade-enter,.fade-leave-to{opacity:0}.windowtitle{background-color:#222d32!important;border-radius:0;cursor:default;top:0;-webkit-user-select:none;-moz-user-select:none;-khtml-user-select:none;-ms-user-select:none}.window{border-radius:0;background-color:#fff;position:absolute;max-height:80%;overflow:hidden;top:10%;width:80%;left:10%;transition:all .5s ease}.distrans{transition:none}.window.infs{height:100%!important;top:0!important;left:0!important;width:100%;max-height:100%}.windowctrl{cursor:pointer}.realcontent{position:relative;overflow:auto;width:100%;height:calc(100% - 32px)}.realcontent.mobilecontent{height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6d7da1c0","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AppWindow.vue
// module id = 365
// module chunks = 0